import { Pipe, PipeTransform } from '@angular/core';
import { statusTimelineKiosko } from '../models/service-request/service-request-kioskos-table';

@Pipe({
  name: 'status',
  pure: false
})
export class StatusTablePipe implements PipeTransform {
  transform(value: string, mr: boolean = true): string {

    const MARGIN_RIGHT = mr ? "mr-1" : "";
    if (value.toLocaleLowerCase() == statusTimelineKiosko.DERIVADO_CON_AVISO) {
      return `<span class="m-1 badge badge-pill badge-light-primary ${MARGIN_RIGHT}">En Proceso</span>`;
    } else if (value.toLocaleLowerCase() == statusTimelineKiosko.AVISO_CERRADO 
    || value.toLocaleLowerCase() ==  statusTimelineKiosko.ANULADO
    || value.toLocaleLowerCase() === statusTimelineKiosko.CONCLUIDO) {
      return `<span class="m-1 badge badge-pill badge-light-danger ${MARGIN_RIGHT}">Atendido</span>`
    } else  {
      return `<span class="m-1 badge badge-pill badge-light-danger ${MARGIN_RIGHT}">Por guardar</span>`
    }
  }

}